import React, { FC, useCallback } from 'react';
import Debug from 'debug';

import toSizedImageUrlNext from '~/app/lib/toSizedImageUrlNext';
import { DesktopSingleColumnLayoutProps } from './types';
import SingleColumnLayout from '../SingleColumnLayout';
import classNames from 'classnames';
import { PAGE_HEADER_HEIGHT } from '~/app/components/PageHeader';
import Background from '../components/Background';

const debug = Debug('songwhip/components/ItemPage');

const SIZED_IMAGE_WIDTH = 1500;
const IMAGE_QUALITY = 60;

const DesktopSingleColumnLayout: FC<DesktopSingleColumnLayoutProps> = ({
  image,
  testId,
  ...singleColumnLayoutProps
}) => {
  debug('render', {
    image,
  });

  const sizedImage =
    image?.url &&
    toSizedImageUrlNext({
      url: image.url,
      width: SIZED_IMAGE_WIDTH,
      quality: IMAGE_QUALITY,
    });

  return (
    <SingleColumnLayout
      testId={classNames('itemPage', 'desktopSingleColumnLayout', testId)}
      spaceBetweenSections="5.2rem"
      renderBackground={useCallback(
        ({ imageRef }) => {
          return (
            <Background
              nodeRef={imageRef}
              image={sizedImage}
              height="100vh"
              withMaskGradient
            />
          );
        },
        [image]
      )}
      spaceAboveContent={
        {
          none: PAGE_HEADER_HEIGHT,
          medium: '24vh',
          large: '60vh',
        }[image.layout.spaceAboveContent]
      }
      {...singleColumnLayoutProps}
    />
  );
};

export default DesktopSingleColumnLayout;
